import format from 'date-fns/format';
import { isValidTimeString } from '@atlassian/jira-issue-format-time/src/index.tsx';
import secondsToTimeString from '@atlassian/jira-issue-view-common-utils/src/time-string/seconds-to-time-string/index.tsx';
import timeStringToSeconds from '@atlassian/jira-issue-view-common-utils/src/time-string/time-string-to-seconds/index.tsx';
import type {
	GetIsTimeEstimateExceededArgs,
	GetCalculatedTimeRemainingIfAnyArgs,
	LogWorkSubmitValue,
	LogWorkValue,
} from './types.tsx';

export const getIsTimeEstimateExceeded = (args: GetIsTimeEstimateExceededArgs): boolean => {
	const { config, timeTrackingValue, timeSpent, timeRemaining } = args;
	const isTimeRemainingValid = isValidTimeString(config)(timeRemaining);
	const isTimeSpentValid = isValidTimeString(config)(timeSpent);
	const isTimeTrackingValid = isValidTimeString(config)(timeTrackingValue);

	if (isTimeTrackingValid && (isTimeRemainingValid || isTimeSpentValid)) {
		let timeSpentInSeconds = 0;
		let timeRemainingInSeconds = 0;
		const timeTrackingValueInSeconds = timeStringToSeconds(
			config.daysPerWeek,
			config.hoursPerDay,
		)(timeTrackingValue);
		if (isTimeSpentValid) {
			// @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
			timeSpentInSeconds = timeStringToSeconds(config.daysPerWeek, config.hoursPerDay)(timeSpent);
		}

		if (isTimeRemainingValid) {
			// @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
			timeRemainingInSeconds = timeStringToSeconds(
				config.daysPerWeek,
				config.hoursPerDay,
			)(timeRemaining);
		}

		timeRemainingInSeconds =
			typeof timeRemainingInSeconds !== 'number' ? 0 : timeRemainingInSeconds;

		timeSpentInSeconds = typeof timeSpentInSeconds !== 'number' ? 0 : timeSpentInSeconds;

		if (typeof timeTrackingValueInSeconds === 'number') {
			if (timeSpentInSeconds + timeRemainingInSeconds > timeTrackingValueInSeconds) {
				return true;
			}
		}
	}
	return false;
};

export const getCalculatedTimeRemainingIfAny = (
	args: GetCalculatedTimeRemainingIfAnyArgs,
): string | null => {
	let calculatedTimeRemaining = null;
	const { timeSpent, timeTrackingValue, config } = args;
	const isValidTimeTrackingValue = isValidTimeString(config)(timeTrackingValue);

	if (!timeSpent && isValidTimeTrackingValue) {
		return timeTrackingValue;
	}
	const isValidTimeSpent = isValidTimeString(config)(timeSpent);
	if (isValidTimeTrackingValue && isValidTimeSpent) {
		const timeSpentInSeconds =
			timeStringToSeconds(config.daysPerWeek, config.hoursPerDay)(timeSpent) || 0;

		const timeTrackingInSeconds =
			timeStringToSeconds(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue) || 0;

		if (timeTrackingInSeconds >= timeSpentInSeconds) {
			calculatedTimeRemaining = secondsToTimeString(
				config.daysPerWeek,
				config.hoursPerDay,
			)(timeTrackingInSeconds - timeSpentInSeconds);
		}
	}

	return calculatedTimeRemaining;
};

export const getLogWorkSubmitValue = (value: LogWorkValue): LogWorkSubmitValue => {
	const { dateValue, timeSpent, timeRemaining, description } = value;
	const adjustEstimate = timeRemaining ? 'new' : 'leave';

	return [
		{
			add: {
				started: dateValue
					? format(new Date(dateValue), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxx")
					: undefined,
				timeSpent,
				adjustEstimate,
				newEstimate: timeRemaining,
				comment: description && JSON.stringify(description),
			},
		},
	];
};
